var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {},
    [
      _c(
        "v-dialog",
        {
          staticClass: "popbox",
          attrs: {
            name: "dialog2",
            title: _vm.dialogTitle,
            "close-on-click-modal": "",
            modal: true,
            width: 668,
            "append-to-body": "",
          },
          on: {
            open: _vm.getDataList,
            "after-close": _vm.handleAfterClose,
            confirm: _vm.handleConfirm,
          },
          model: {
            value: _vm.isShow,
            callback: function ($$v) {
              _vm.isShow = $$v
            },
            expression: "isShow",
          },
        },
        [
          _c(
            "v-form",
            { ref: "form", attrs: { model: _vm.ruleForm, rules: _vm.rules } },
            [
              _c(
                "v-form-item",
                { attrs: { prop: "product_key" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("产品")]),
                  ]),
                  _c("v-select", {
                    attrs: {
                      id: "product_key",
                      name: "product_key",
                      options: _vm.productOptins,
                    },
                    model: {
                      value: _vm.ruleForm.product_key,
                      callback: function ($$v) {
                        _vm.$set(_vm.ruleForm, "product_key", $$v)
                      },
                      expression: "ruleForm.product_key",
                    },
                  }),
                ],
                2
              ),
              _c(
                "v-form-item",
                { staticClass: "listfile", attrs: { prop: "listFile" } },
                [
                  _c("template", { slot: "label" }, [
                    _c("span", { staticClass: "required" }, [_vm._v("*")]),
                    _c("span", [_vm._v("上传文件")]),
                  ]),
                  _c("v-upload", {
                    ref: "upload",
                    attrs: {
                      action: "/td/td-iot-api/iot/dev/upload/v1",
                      name: "dev_file",
                      accept: ".xlsx",
                      WfileName: _vm.WfileName,
                      updataType: "excell",
                      "on-change": _vm.hidemsg,
                      noName: _vm.noName,
                      "show-file-list": "",
                    },
                    on: { showtips: _vm.showfiletips },
                  }),
                  _c(
                    "span",
                    [
                      _c(
                        "v-button",
                        {
                          staticClass: "ml10",
                          attrs: {
                            slot: "reference",
                            size: "M",
                            type: "text",
                            name: "btn2",
                          },
                          on: { click: _vm.downFile },
                          slot: "reference",
                        },
                        [_vm._v("下载模板")]
                      ),
                    ],
                    1
                  ),
                  _c("div", { ref: "filetip", staticClass: "filetip" }, [
                    _vm._v("未选择文件"),
                  ]),
                ],
                2
              ),
            ],
            1
          ),
          _c("v-loading", {
            staticClass: "loading-box",
            attrs: { visible: !_vm.upTips, name: "loading4" },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }